/* eslint-disabled */
import ItemProperty from "./ItemProperty";
import Item from "./Item";
import PropertyValue from "./PropertyValue";
import PropertyExtend from "@/entity/extends/PropertyExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Property extends PropertyExtend {

    public id?: number;
    public uuid? = '';
    public model!: ItemProperty;
    public value? = '';
    public item!: Item;
    public children: Array<Item> = [];
    public removedAt?: Date;
    public propertyValues: Array<PropertyValue> = [];
    public deletedAt?: Date;
    public visible ?: boolean;

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;
            this.uuid = object.uuid;
            this.model = (object.model instanceof ItemProperty) ? object.model : object.model ? new ItemProperty(object.model) : object.model;
            this.value = object.value;
            this.visible = object.visible;
            this.item = (object.item instanceof Item) ? object.item : object.item ? new Item(object.item) : object.item;
            hydrateCollection(object.children, Item, this.children);
            if (object.removedAt) {
                this.removedAt = new Date(object.removedAt);
            }
            hydrateCollection(object.propertyValues, PropertyValue, this.propertyValues);
            if (object.deletedAt) {
                this.deletedAt = new Date(object.deletedAt);
            }
        }
        this.postConstruct()
    }

}
